var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{staticClass:"expo-btn expo-btn-white",attrs:{"href":'mailto:' + _vm.item.email,"title":_vm.$t('general.send_email', { mail: _vm.item.email })}},[_c('b-icon-envelope'),_vm._v("  "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }